<template>
  <section>
    <b-tabs v-model="currentTabIndex" :animated="false" type="is-toggle">
      <b-tab-item :value="0" :label="$t('graePage.details.projets.title')">
        <GraeProjectsView v-if="currentTabIndex == 0" :grae-id="grae ? grae.id : undefined" />
      </b-tab-item>

      <b-tab-item :value="1" :label="$t('graePage.details.etablissements.title')">
        <GraeEtablissementsView v-if="currentTabIndex == 1" :grae-id="grae ? grae.id : undefined" />
      </b-tab-item>

      <b-tab-item :value="2" :label="$t('graePage.details.structures.title')">
        <GraeStructuresView v-if="currentTabIndex == 2" :grae-id="grae ? grae.id : undefined" />
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"

import { GraeDTO } from "@/model/bean/GeneratedDTOs"
import GraeProjectsView from "@/views/grae/GraeProjectsView.vue"
import GraeEtablissementsView from "@/views/grae/GraeEtablissementsView.vue"
import GraeStructuresView from "@/views/grae/GraeStructuresView.vue"
import { BTabs, BTabItem } from "buefy"

export default defineComponent({
  name: "GraeDetailsView",
  components: {
    GraeProjectsView,
    GraeEtablissementsView,
    GraeStructuresView,
    BTabs,
    BTabItem,
  },
  props: {
    grae: {
      type: Object as PropType<GraeDTO | undefined>,
      default: undefined,
    },
    activeTab: {
      type: Number,
      default: 0,
    },
    lowerTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTabIndex: 0,
    }
  },
  watch: {
    currentTabIndex(_newCurrentTabIndex: number, _oldCurrentTabIndex: number): void {
      const currentRoute = this.$router.currentRoute.value
      const currentActiveSubTab = currentRoute.params["activeSubTab"]
      const newQuery = { ...currentRoute.query }

      let queryChanged = false
      if (this.currentTabIndex !== 0 && Object.prototype.hasOwnProperty.call(newQuery, "filters")) {
        delete newQuery.filters
        queryChanged = true
      }

      const activeSubTabChanged = this.currentTabIndex?.toString() !== currentActiveSubTab

      if (activeSubTabChanged || queryChanged) {
        const newParams = {
          ...currentRoute.params,
          activeSubTab: this.currentTabIndex.toString(),
        }

        this.$router.push({
          name: currentRoute.name?.toString(),
          params: newParams,
          query: newQuery,
          hash: currentRoute.hash,
        })
      }
    },
  },
  mounted(): void {
    this.currentTabIndex = this.activeTab
  },
})
</script>
